export default "__VITE_ASSET__cd24a60d__"